export default __webpack_public_path__ + "static/media/about.bc03ce71.png";